import React from 'react';
import propTypes from 'prop-types';

import './Header.css';

const Header = props => (
  <header className={`header ${props.type ? props.type : ''} ${props.className}`}>
    {
      props.pretitle &&
      <h4 className="header__pretitle">{props.pretitle}</h4>
    }
    {
      props.title &&
      <h2 className="header__title">{props.title}</h2>
    }
    {
      props.subtitle &&
      <h3 className="header__subtitle">{props.subtitle}</h3>
    }
  </header>
);

export default Header;

Header.propTypes = {
  title: propTypes.string,
  subtitle: propTypes.string,
  pretitle: propTypes.string,
  type: propTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Header/Header.js